/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { useFormik, useFormikContext } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'
import { useAuth } from '../../../../app/modules/auth/core/Auth'
import { getUserByToken, register } from '../../../../app/modules/auth/core/_requests'
import { Modal } from 'react-bootstrap'
import { clear } from 'console'
import Swal from 'sweetalert2'
import { AxiosError } from 'axios'

const initialValues = {
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    changepassword: '',
    acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
    firstname: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('First name is required'),
    email: Yup.string()
        .email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
    lastname: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Last name is required'),
    password: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
    changepassword: Yup.string()
        .required('Password confirmation is required')
        .when('password', {
            is: (val: string) => (val && val.length > 0 ? true : false),
            then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
        }),
    acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

type Props = {
    display: boolean,
    setDisplay: Function
}

const RegisterModal = ({ display, setDisplay }: Props) => {
    const [loading, setLoading] = useState(false)
    const { saveAuth, setCurrentUser } = useAuth()

    function redirectToHome(){
        window.location.href = "/home";
    }
    
    const formik = useFormik({
        initialValues,
        validationSchema: registrationSchema,
        onSubmit: async (values, { setStatus, setSubmitting, resetForm }) => {
            setLoading(true)
            try {
                const { data: auth } = await register(
                    values.email,
                    values.firstname,
                    values.lastname,
                    values.password,
                    values.changepassword
                )

                setLoading(false)
                let res = JSON.stringify(auth)

                Swal.fire({
                    title: 'Success!',
                    text: 'กรุณาตรวจสอบอีเมลและทำการ activate เพื่อเริ่มใช้งานบัญชี',
                    icon: 'success',
                    didClose: ()=>{
                        redirectToHome()
                    }
                }).then(()=>{
                    resetForm();
                    setDisplay(false)
                })
                
            } catch (e) {
                console.error('error: '+e)
                const err = e as AxiosError
                const error_data = err.response?.data
                const error_msg = error_data.msg ?? 'The registration details is incorrect'

                Swal.fire({
                    title: 'เกิดข้อผิดพลาด!',
                    text: error_msg,
                    icon: 'warning'
                })

                saveAuth(undefined)
                setStatus(error_msg)
                setSubmitting(false)
                setLoading(false)
            }
        },
    })

    useEffect(() => {
        PasswordMeterComponent.bootstrap()
    }, [])

    const clear = () => {
        
    }

    return (
        <Modal
            id="register_modal"
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px'
            show={display}
            onEntered={clear}
            >
            <div className="modal-header">
                <h5 className="modal-title">ลงทะเบียน</h5>
                <div
                    className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                        setDisplay(false)
                    }}
                >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr061.svg"
                        className="svg-icon svg-icon-2x"
                    />
                </div>
            </div>
            <div className="modal-body">
                <form
                    className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                    noValidate
                    id='kt_login_signup_form'
                    onSubmit={formik.handleSubmit}
                >
                    {/* begin::Heading */}
                    <div className='mb-10 text-center'>
                        {/* begin::Title */}
                        <h1 className='text-dark mb-3'>ลงทะเบียนเข้าใช้งานระบบ</h1>
                        {/* end::Title */}
                    </div>
                    {/* end::Heading */}

                    {/* begin::Action */}

                    {formik.status && (
                        <div className='mb-lg-15 alert alert-danger'>
                            <div className='alert-text font-weight-bold'>{formik.status}</div>
                        </div>
                    )}

                    {/* begin::Form group Firstname */}
                    <div className='row fv-row mb-7'>
                        <div className='col-xl-6'>
                            <label className='class="form-label fw-bolder text-dark fs-6'>ชื่อ</label>
                            <input
                                placeholder='First name'
                                type='text'
                                autoComplete='off'
                                {...formik.getFieldProps('firstname')}
                                className={clsx(
                                    'form-control form-control-lg form-control-solid',
                                    {
                                        'is-invalid': formik.touched.firstname && formik.errors.firstname,
                                    },
                                    {
                                        'is-valid': formik.touched.firstname && !formik.errors.firstname,
                                    }
                                )}
                            />
                            {formik.touched.firstname && formik.errors.firstname && (
                                <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                        <span role='alert'>{formik.errors.firstname}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='col-xl-6'>
                            {/* begin::Form group Lastname */}
                                <label className='form-label fw-bolder text-dark fs-6 mb-0'>นามสกุล</label>
                                <input
                                    placeholder='Last name'
                                    type='text'
                                    autoComplete='off'
                                    {...formik.getFieldProps('lastname')}
                                    className={clsx(
                                        'form-control form-control-lg form-control-solid',
                                        {
                                            'is-invalid': formik.touched.lastname && formik.errors.lastname,
                                        },
                                        {
                                            'is-valid': formik.touched.lastname && !formik.errors.lastname,
                                        }
                                    )}
                                />
                                {formik.touched.lastname && formik.errors.lastname && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span role='alert'>{formik.errors.lastname}</span>
                                        </div>
                                    </div>
                                )}
                            {/* end::Form group */}
                        </div>
                    </div>
                    {/* end::Form group */}

                    {/* begin::Form group Email */}
                    <div className='fv-row mb-7'>
                        <label className='form-label fw-bolder text-dark fs-6'>อีเมล</label>
                        <input
                            placeholder='Email'
                            type='email'
                            autoComplete='off'
                            {...formik.getFieldProps('email')}
                            className={clsx(
                                'form-control form-control-lg form-control-solid',
                                { 'is-invalid': formik.touched.email && formik.errors.email },
                                {
                                    'is-valid': formik.touched.email && !formik.errors.email,
                                }
                            )}
                        />
                        {formik.touched.email && formik.errors.email && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.email}</span>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* end::Form group */}

                    {/* begin::Form group Password */}
                    <div className='mb-10 fv-row' data-kt-password-meter='true'>
                        <div className='mb-1'>
                            <label className='form-label fw-bolder text-dark fs-6'>รหัสผ่าน</label>
                            <div className='position-relative mb-3'>
                                <input
                                    type='password'
                                    placeholder='Password'
                                    autoComplete='off'
                                    {...formik.getFieldProps('password')}
                                    className={clsx(
                                        'form-control form-control-lg form-control-solid',
                                        {
                                            'is-invalid': formik.touched.password && formik.errors.password,
                                        },
                                        {
                                            'is-valid': formik.touched.password && !formik.errors.password,
                                        }
                                    )}
                                />
                                {formik.touched.password && formik.errors.password && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span role='alert'>{formik.errors.password}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {/*<div
                                className='d-flex align-items-center mb-3'
                                data-kt-password-meter-control='highlight'
                            >
                                <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                                <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                                <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                                <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
                            </div>*/}
                        </div>
                        {/*<div className='text-muted'>
                            Use 8 or more characters with a mix of letters, numbers & symbols.
                        </div>*/}
                    </div>
                    {/* end::Form group */}

                    {/* begin::Form group Confirm password */}
                    <div className='fv-row mb-5'>
                        <label className='form-label fw-bolder text-dark fs-6'>ยืนยันรหัสผ่าน</label>
                        <input
                            type='password'
                            placeholder='Password confirmation'
                            autoComplete='off'
                            {...formik.getFieldProps('changepassword')}
                            className={clsx(
                                'form-control form-control-lg form-control-solid',
                                {
                                    'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
                                },
                                {
                                    'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
                                }
                            )}
                        />
                        {formik.touched.changepassword && formik.errors.changepassword && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.changepassword}</span>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* end::Form group */}

                    {/* begin::Form group */}
                    <div className='fv-row mb-10'>
                        <div className='form-check form-check-custom form-check-solid'>
                            <input
                                className='form-check-input'
                                type='checkbox'
                                id='kt_login_toc_agree'
                                {...formik.getFieldProps('acceptTerms')}
                            />
                            <label
                                className='form-check-label fw-bold text-gray-700 fs-6'
                                htmlFor='kt_login_toc_agree'
                            >
                                ข้าพเจ้ายินยอมรับ{' '}
                                <Link to='/media/pdfs/PDPA.pdf' target="_blank" className='ms-1 link-primary'>
                                นโยบายความเป็นส่วนตัว เงื่อนไข และข้อกำหนด{' '}
                                </Link>
                                ตามที่มหาวิทยาลัยธรรมศาสตร์ได้กำหนดไว้ทุกประการ.
                            </label>
                            {formik.touched.acceptTerms && formik.errors.acceptTerms && (
                                <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                        <span role='alert'>{formik.errors.acceptTerms}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* end::Form group */}

                    {/* begin::Form group */}
                    <div className='text-center'>
                        <button
                            type='submit'
                            id='kt_sign_up_submit'
                            className='btn btn-lg btn-primary w-100 mb-5'
                            disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
                        >
                            {!loading && <span className='indicator-label'>ลงทะเบียน</span>}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                        <Link to='/auth/login'>
                            <button
                                type='button'
                                id='kt_login_signup_form_cancel_button'
                                className='btn btn-lg btn-light w-100 mb-5'
                                onClick={() => {
                                    setDisplay(false)
                                }}
                            >
                                ยกเลิก
                            </button>
                        </Link>
                    </div>
                    {/* end::Form group */}
                </form>
            </div>
            <div className="modal-footer">
                
            </div>
        </Modal>

    )
}

export { RegisterModal }